import { render } from "./Star.vue.js?vue&type=template&id=7a8a7db5!=!../vue-loader/dist/index.js??ruleSet[0]!./Star.vue?vue&type=template&id=7a8a7db5"
import script from "./Star.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Star.vue?vue&type=script&lang=js"
export * from "./Star.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Star.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__